module.exports = __webpack_public_path__ + "static/bsfcu-branch.51c783d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/locator/types/bsfcu-branch.png
// module id = 4386
// module chunks = 168707334958949